import { AnalyzedToken } from "src/app/shared/models/analyzed-token.model";
import { Translation } from "src/app/shared/models/translation.model";
import { Entry } from "../interfaces/entry.model";
import { LexicalEntry } from "../interfaces/lexical-entry.model";
import { QueryForm } from "../interfaces/query-form.model";
import { ReduceResource } from "../interfaces/reduce-resource.model";
import { SearchTokenResp } from "../interfaces/search-token-resp.model";
import { SemanticGroupTextualForms } from "../interfaces/semantic-group-textual-forms.model";
import { POS } from "./ricerca.actions";

/**Interfaccia dello stato dell'applicazione per la sezione di ricerca avanzata */
export interface State {
    /**Albero completo delle risorse con radice Talmud */
    resourceList: ReduceResource;
    /**Elenco delle POS disponibili */
    posList: POS[];
    /**Elenco dei sensi lessicali disponibili */
    lexicalSenses: Entry[];
    /**Elenco degli id di risorsa selezionati per la ricerca */
    selectedResources: number[];
    /**Oggetto che memorizza i parametri selezionati sul form di ricerca */
    queryForm: QueryForm;
    formsList : SemanticGroupTextualForms[];
    lexEntryDialogVisible: boolean;
    workingLexicalEntry: LexicalEntry;
    morphTraitDialogVisible: boolean;
    morphTraitDialogPos: string;
    morphTraitDialogMus: string;
    selectedMorphList: {mus: string, morph: any}[];
    occurrenceList: SearchTokenResp;
    sensesByConcept: Entry[];
    selectedSensesByConcept: string[];
    selectedSensesByTraits: string[];
    totalLoadingStep: number;
    executedLoadingStep: number;
    analyzedSentence: AnalyzedToken[];
}

/**Stato iniziale della sezione Ricerca avanzata dell'applicazione */
export const initialState: State = {} as State;